import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-expandable',
    templateUrl: './expandable.component.html',
    styleUrls: ['./expandable.component.scss'],
    standalone: false
})
export class ExpandableComponent implements OnInit {

  showmore: boolean = false;

  @Input() title: string;
  @Input() content: string;

  constructor() { }

  ngOnInit(): void {
  }

  isEllipsisActive(e) {
    return (e.offsetWidth < e.scrollWidth);
  }

}
